import React from "react";
import { workflowToneStyle } from "../data/workflows";
import { useT } from "../i18n";
import { useContent } from "../i18n/useContent";
import "./Workflows.css";

const pad = (n) => String(n).padStart(2, "0");

const Workflows = () => {
  const t = useT();
  const { workflows } = useContent();

  return (
  <section id="workflows" className="workflows">
    <div className="container">
      <header className="masthead reveal">
        <div className="masthead-rule">
          <span className="masthead-label">{t('workflows.label')}</span>
          <span className="masthead-note">{t('workflows.count', { count: workflows.length })}</span>
        </div>
        <h2 className="masthead-title">{t('workflows.title')}</h2>
        <p className="masthead-lede">{t('workflows.lede')}</p>
      </header>

      <div className="workflow-list">
        {workflows.map((workflow, index) => (
          <article
            key={workflow.id}
            className="workflow reveal"
            style={workflowToneStyle(workflow.tone)}
          >
            <div className="workflow-head">
              <span className="workflow-index" aria-hidden="true">
                {pad(index + 1)}
              </span>
              <div className="workflow-heading">
                <p className="workflow-type">{workflow.type}</p>
                <h3 className="workflow-name">{workflow.name}</h3>
              </div>
              <span className="workflow-cadence">{workflow.cadence}</span>
            </div>

            <p className="workflow-problem">{workflow.problem}</p>

            <div className="workflow-body">
              <div className="workflow-main">
                <h4 className="workflow-block-title">{t('workflows.pipeline')}</h4>
                {/* The stages are the substance of a workflow, so they get the
                    wide column: a numbered spine you can read top to bottom. */}
                <ol className="pipeline">
                  {workflow.stages.map((stage, stageIndex) => (
                    <li
                      className="stage reveal"
                      key={stage.label}
                      style={{ '--i': stageIndex }}
                    >
                      <span className="stage-num" aria-hidden="true">
                        {pad(stageIndex + 1)}
                      </span>
                      <div className="stage-body">
                        <p className="stage-label">{stage.label}</p>
                        <p className="stage-detail">{stage.detail}</p>
                      </div>
                    </li>
                  ))}
                </ol>

                <h4 className="workflow-block-title">{t('workflows.notes')}</h4>
                <ul className="workflow-notes">
                  {workflow.notes.map((note) => (
                    <li key={note}>{note}</li>
                  ))}
                </ul>
              </div>

              <aside className="workflow-side">
                <h4 className="workflow-block-title">{t('workflows.atAGlance')}</h4>
                <dl className="workflow-facts">
                  {workflow.facts.map((fact) => (
                    <div className="workflow-fact" key={fact.key}>
                      <dt>{fact.key}</dt>
                      <dd>{fact.value}</dd>
                    </div>
                  ))}
                </dl>

                <h4 className="workflow-block-title">{t('workflows.builtWith')}</h4>
                <div className="workflow-chips">
                  {workflow.stack.map((tech) => (
                    <span key={tech} className="chip">
                      {tech}
                    </span>
                  ))}
                </div>
              </aside>
            </div>
          </article>
        ))}
      </div>
    </div>
  </section>
  );
};

export default Workflows;
